
export default {
  props: {
    config: {
      type: Object,
      required: true,
    },
    fixture: {
      type: Object,
      required: true,
    },
  },
  inject: [`refresh`],
  data () {
    return {
      stats: {},
      homeDataLoaded: false,
      awayDataLoaded: false,
      shots: {}, // Different call to regular stats
      homeShotsLoaded: false,
      awayShotsLoaded: false,
      statsRefreshInterval: null,
    };
  },
  computed: {
    homeTeam () {
      return this.getTeam(this.fixture, `Home`);
    },
    awayTeam () {
      return this.getTeam(this.fixture, `Away`);
    },
    seasonId () {
      return this.fixture.stage.seasonId;
    },
    displayStats () {
      return this.homeDataLoaded && this.awayDataLoaded;
    },
    displayShots () {
      return this.homeShotsLoaded && this.awayShotsLoaded;
    },
    legendTitles () {
      return [this.homeTeam.team.teamNames[0].displayName, this.awayTeam.team.teamNames[0].displayName];
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getStats();
      this.getStats(`away`);

      if (this.config.stats.find(stat => stat.display_type === `goal`)) {
        this.getShots();
        this.getShots(`away`);
      }

      if (this.refresh) {
        this.statsRefreshInterval = setInterval(() => {
          this.getStats();
          this.getStats(`away`);

          if (this.config.stats.find(stat => stat.display_type === `goal`)) {
            this.getShots();
            this.getShots(`away`);
          }
        }, this.refresh);
      }
    });
  },
  beforeDestroy () {
    // Stop refresh
    if (this.statsRefreshInterval) {
      clearInterval(this.statsRefreshInterval);
    }
  },
  methods: {
    async getStats (side = `home`) {
      const params = {
        stat_types: [...this.config.stats]
          .filter(stat => stat.team_stat.teamstattype.length || stat.team_stat.computedteamstattype.length)
          .map(stat => stat.team_stat.teamstattype.length ? stat.team_stat.teamstattype.map(stat => stat.displayName) : stat.team_stat.computedteamstattype.map(stat => stat.displayName))
          .flat()
          .join(`||`),
      };
      const teamId = side === `home` ? this.homeTeam.team.id : this.awayTeam.team.id;

      const request = await this.$getCustomStats(`season/${this.seasonId}/team/${teamId}/fixture/${this.fixture.id}/`, params);
      if (request !== null) {
        this.stats[side] = request.entity_stats;
        if (side === `home`) {
          this.homeDataLoaded = true;
        } else {
          this.awayDataLoaded = true;
        }
      }
    },
    async getShots (side = `home`) {
      const teamId = side === `home` ? this.homeTeam.team.id : this.awayTeam.team.id;
      const request = await this.$getCustomStats(`season/${this.seasonId}/shotplacement/team/${teamId}/fixture/${this.fixture.id}`);
      if (request !== null) {
        this.shots[side] = request;
        if (side === `home`) {
          this.homeShotsLoaded = true;
        } else {
          this.awayShotsLoaded = true;
        }
      }
    },
    getStatName (stat) {
      const statKey = this.getStatKey(stat);
      return stat.name_override !== ``
        ? stat.name_override
        : this.stats.home[statKey].display_name;
    },
    getStatKey (stat) {
      return stat.team_stat.teamstattype.length
        ? stat.team_stat.teamstattype[0].displayName
        : stat.team_stat.computedteamstattype[0].displayName;
    },
    getPieData (stat) {
      const statKey = this.getStatKey(stat);
      return [
        {
          name: this.homeTeam.team.teamNames[0].displayName,
          label: this.homeTeam.team.teamNames[0].displayName,
          value: this.stats.home[statKey].value,
        },
        {
          name: this.awayTeam.team.teamNames[0].displayName,
          label: this.awayTeam.team.teamNames[0].displayName,
          value: this.stats.away[statKey].value,
        },
      ];
    },
    getStatData (stat) {
      const statKey = this.getStatKey(stat);
      return [
        this.stats.home[statKey].value,
        this.stats.away[statKey].value,
      ];
    },
    getRadarData (stat) {
      const keys = [
        ...stat.team_stat.teamstattype.map(stat => stat.displayName),
        ...stat.team_stat.computedteamstattype.map(stat => stat.displayName),
      ];

      return [
        {
          name: this.homeTeam.team.teamNames[0].displayName,
          label: this.homeTeam.team.teamNames[0].displayName,
          value: keys.map(key => this.stats.home[key].value),
        },
        {
          name: this.awayTeam.team.teamNames[0].displayName,
          label: this.awayTeam.team.teamNames[0].displayName,
          value: keys.map(key => this.stats.away[key].value),
        },
      ];
    },
    getRadarTitles (stat) {
      const keys = [
        ...stat.team_stat.teamstattype.map(stat => stat.displayName),
        ...stat.team_stat.computedteamstattype.map(stat => stat.displayName),
      ];
      const titles = keys.map(key => this.stats.home[key].display_name);
      return titles;
    },
  },
};
